import { DatePipe } from '@angular/common';
import { TranslatePipe } from '../../filters/translate.pipe';
import {Component, OnInit, inject, HostListener} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import Session from '../../utils/session.service';
import CategoryService from '../../services/category.service';
import DialogServices from '../../services/dialog.service';
import ServiceRestServices from '../../services/service-rest.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import { Input } from '@angular/core';
import { ModalBookingEnquiryComponent } from '../modal-booking-enquiry/modal-booking-enquiry.component';
import AngularHelperService from "../../services/angular-helper.service";
import AngularBroadcastHelperService from "../../services/angular-broadcast-helper.service";
import AngularFilterHelperService from "../../services/angular-filter-helper.service";
import ChatRestServices from "../../services/chat-rest.service";
import Config from "../../utils/config.service";

@Component({
	standalone: true,
	selector: 'item-message-business-card',
	templateUrl: './item-message-business-card.component.html',
	imports: [ CommonModule, DatePipe, TranslatePipe, FormsModule, RouterLink ]
})
export class ItemMessageBusinessCardComponent implements OnInit {
	private session: Session = inject(Session);
	private categoryService: CategoryService = inject(CategoryService);
	private dialogServices: DialogServices = inject(DialogServices);
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private chatRestServices: ChatRestServices = inject(ChatRestServices);
	private config: Config = inject(Config);
	
	@Input() lastSeen: any | undefined;
	@Input() chat: any;
	@Input() group: any;
	
	vm: any = undefined;
	activeMessage: any | null = null;
	isDesktop = window.innerWidth >= 768;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.user = this.session.getSession().user;
		this.vm.message = this.vm.group.messages[0];
		this.vm.uid = 'ibc-' + this.vm.message.id;
		
		var metadata: any = this.vm.message && this.vm.message.metadatas && this.vm.message.metadatas.find((item) => {
			return item.type === 'BUSINESS_CARD';
		});
		
		if (metadata) {
			try {
				this.vm.metadata = JSON.parse(metadata.metadata);
				this.vm.metadata.type = metadata.type;
			} catch (e) {
				console.error(e);
			}
		}
		this.vm.isValidPictureUrl = this.isValidPictureUrl;
		this.vm.book = this.book;
		this.vm.onMouseLeave = this.onMouseLeave;
		this.vm.onMouseEnter = this.onMouseEnter;
		this.vm.deleteMessage = this.deleteMessage;
		this.vm.toggleActions = this.toggleActions;
		
		this.categoryService.getAll().then((categories) => {
			this.vm.healthFields = categories;
			this.loadOccupation();
		});
	}
	
	book() {
		this.serviceRestServices.getServiceById({ id: this.vm.metadata.id }, (service) => {
			if (service.nextAvailableTime) {
				this.openBookingView();
			} else {
				this.openBookingEnquiry(service);
			}
		});
	}
	
	openBookingEnquiry(service) {
		this.dialogServices.show({
			controller: ModalBookingEnquiryComponent,
			service: service
		});
	}
	
	openBookingView() {
		this.angularRoutingHelperService.setPath(["booking/service/", this.vm.metadata.id]);
	}
	
	isValidPictureUrl(pictureUrl) {
		return pictureUrl && pictureUrl.startsWith('http');
	}
	
	loadOccupation() {
		this.vm.occupation = this.categoryService.getTranslationUsingDictionary(this.vm.healthFields,
			{ subcategory: this.vm.metadata.subcategory, furtherSubcategory: this.vm.metadata.furtherSubcategory });
	}

	onMouseEnter(message: any) {
		if (this.isDesktop) {
			message.showDots = true;
		}
	}

	onMouseLeave(message: any) {
		if (this.isDesktop) {
			message.showDots = false;
		}
	}

	toggleActions(message: any, event: Event, container: HTMLElement) {
		event.stopPropagation();
		message.showActions = !message.showActions;

		message.showDots = true;

		this.activeMessage = message.showActions ? { message, container } : null;
	}

	@HostListener('document:click', ['$event'])
	onClickOutside(event: Event) {
		if (!this.activeMessage) return;

		const target = event.target as HTMLElement;
		const { message, container } = this.activeMessage;

		if (message.showActions && container && !container.contains(target)) {
			message.showActions = false;
			if (this.isDesktop) message.showDots = false;
			this.activeMessage = null;
		}
	}


	deleteMessage(message: any) {
		this.handleDeleteMessage(message);
	}

	handleDeleteMessage(textMessage: any) {
		var dialog = this.dialogServices.confirmation({
			title: this.angularFilterHelperService.translate('Modal.Title.Confirm'),
			content: this.angularFilterHelperService.translate('Modal.Content.Delete_Message_Confirmation'),
		});
		dialog.afterClosed().subscribe((data) => {
			if (data) {
				this.vm.loading = true;
				var chat: any = this.angularHelperService.copy(this.vm.chat);
				var message: any = {
					id: textMessage.id,
					content: this.angularFilterHelperService.translate('Chats.Other.Deleted'),
					chat: {
						id: this.vm.chat.id
					}
				};

				this.chatRestServices.updateChatMessage(
					{ forUser: this.vm.chat.privateChatFriend.id, isDeleted: true }, message,
					(res) => {
						this.vm.loading = false;
						this.angularBroadcastHelperService.rootBroadcast(this.config.getBroadcastConfig().Chat.CHAT_POST_DELETED, [res], chat.id);
					},
					(err) => {
						console.error(err);
						this.vm.loading = false;
					}
				);
			}
		});
	}
	
}